import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=f454370a&scoped=true&"
import script from "./KanbanColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=f454370a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f454370a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VChip,VToolbar})
